import { IAddOn } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { IProductAddOn } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { IAddons } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import {
  IProductChildMinimizedData,
  IProductMinimizedData,
} from "../pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";

export const intersectionsArray = <T>(arr1: T[], arr2: T[]) =>
  arr1.filter((value) => arr2?.includes(value));

export const attrsInitValues = (
  attrs: IFilter[],
  selectedAttrs: number[] = [],
) => {
  if (!attrs || attrs.length === 0) return {};
  const values = attrs?.reduce((acc, attr) => {
    let fConfig = attr?.configurations;
    if (selectedAttrs.length === 0) return { ...acc, [fConfig.key]: [] };
    const attrKeys = attr?.data?.map((attr) => +attr.key);
    const intersection = intersectionsArray(selectedAttrs, attrKeys ?? []);
    return {
      ...acc,
      [fConfig.key]: intersection.map((i) => i?.toString()),
    };
  }, {});
  return values;
};
export const getUnavailableAttributes = (
  currentKey: string,
  newState: string[],
  product: IProductMinimizedData,
) => {
  const isAvailable = (attr: string, attrIds: number[][]) => {
    for (let i = 0; i < attrIds.length; i++) {
      const virtual = [+attr, ...newState.map((s) => +s)];
      const intersection = intersectionsArray(virtual, attrIds[i]);
      if (intersection.length === virtual.length) return true;
    }
    return false;
  };
  const attribsToCheck = product.attributes_builder.filter(
    (attr) => attr.configurations.key !== currentKey,
  );
  const attrs = attribsToCheck
    .map((attr) => attr.data)
    .flat()
    .map((prop) => prop?.key);
  const childrenAttrIds = product?.children.map((child) => child.attribute_ids);
  let unAvailable: string[] = [];
  attrs.forEach((attr) => {
    if (!isAvailable(attr!, childrenAttrIds)) unAvailable.push(attr!);
  });
  const currentUnavailabe = attrsInitValues(
    attribsToCheck,
    unAvailable.map((s) => +s),
  );
  return currentUnavailabe;
};
export const getIndexOfChild = (
  children: IProductChildMinimizedData[],
  newState: { [x: string]: string[] },
) => {
  //no child is selected if not all attribs are selected
  if (Object.keys(newState)?.length === 0) return null;
  for (let key of Object.keys(newState)) {
    if (!newState[key] || newState[key]?.length === 0) {
      return null;
    }
  }
  const stateArr = Object.values(newState)
    .flat(1)
    .map((attr) => +attr);
  for (let i = 0; i < children.length; i++) {
    if (
      intersectionsArray(stateArr, children[i].attribute_ids).length ===
      stateArr.length
    )
      return i;
  }
  return -1;
};

// export const addOnsInitValues = (
//   addonFields: IProductAddOn[],
//   addOns: IAddOn[],
// ) => {
//   if (!addonFields || addonFields.length === 0) return;
//   const values = addonFields?.reduce((acc, field) => {
//     let fConfig = field?.configurations;
//     if (addOns.length === 0) return { ...acc, [fConfig.key]: [] };
//     const addonIds = addOns.map((addon) => addon.id);
//     const addonFieldsIds = field.data.map((addon) => addon.id);
//     const intersection = intersectionsArray(addonIds, addonFieldsIds);
//     return {
//       ...acc,
//       [fConfig.key]: fConfig.is_multi_select
//         ? intersection
//         : [intersection[0]] ?? [],
//     };
//   }, {});
//   return values;
// };
export const addonsInitValues = (addons: IAddOn[]) => {
  const productAddons: IAddons = {};
  if (addons?.length === 0) return;

  addons.forEach((addon) => {
    productAddons[addon.key] = addons
      .filter((ad) => ad.key === addon.key)
      .map((ad) => ({ id: ad.id, quantity: ad.quantity ?? 1 }));
  });

  return productAddons;
};

export const renameAddonFields = (addonFields: IProductAddOn[]) => {
  if (!addonFields) return;
  const values = addonFields?.map((field) => {
    let fConfig = { ...field.configurations };
    fConfig.key = fConfig.key.replaceAll("[", "(").replaceAll("]", ")");
    return { ...field, configurations: fConfig };
  });
  return values;
};
